class TreeNode {
  constructor(key, parent = null, data = null) {
    this.id = key;
    this.parentId = parent;
    this.data = data;
    this.childrenNodes = [];
    this.childrenMap = new Map();
    this.isLeaf = true;
  }

  findAnyData(fn) {
    const nodes = this.childrenNodes;
    if (nodes.length === 0) return fn(this.data);
    return nodes.find((x) => x.findAnyData(fn));
  }

  getDescendants() {
    const nodes = this.childrenNodes;
    if (nodes.length === 0) return [this.data];
    return nodes
      .map((x) => x.getDescendants())
      .reduce((a, i) => a.concat(i), []);
  }

  setParent(node) {
    this.parentId = node?.id || null;
    if (node) node.addChild(this);
    return this;
  }

  addChild(child) {
    this.childrenMap.set(child.id, child);
    this.childrenNodes = Array.from(this.childrenMap.values());
    this.isLeaf = false;
    return this;
  }
}

export default TreeNode;
